import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  toggle: {
    marginTop: 24,
    marginBottom: 24,
    '& .MuiTypography-root': {
      color: theme.palette.common.black,
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  field: {
    '& textarea': {
      height: '60px !important',
    },
    '& .MuiFormHelperText-root': {
      textAlign: 'right',
    },
  },
}))
